import { useEffect } from "react";

import FeatureGates from "@atlaskit/feature-gate-js-client";

import { IntercomProvider } from "@/libraries/intercom/src";
import { JiraServiceManagementPricingPageV2Template } from "@/templates/software/jira/service-management/pricing/jira-service-management-pricing-page-v2/src";
import { experiments, useExperimentExposure } from "@/utils/experiment";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";
import { PricingContent } from "@/utils/pricing-queries/get-pricing-content";

import { PricingContentContextProvider } from "../../../../../components/wpl/pricing/src/pricing-content-context.tsx";
import { AppPricingData } from "../../../../../contentful";
import { UserLocale } from "../../../../../utils/useGeoCurrency";

import { getPricingTitleInternal } from "./feature-gates.ts";

export type JiraServiceManagementPricingPageProps = {
    pricing?: AppPricingData;
    countryCode?: UserLocale;
    pricingContent?: PricingContent;
};

export const JiraServiceManagementPricingPage = ({
    pricing,
    countryCode,
    pricingContent
}: JiraServiceManagementPricingPageProps) => {
    useEffect(() => {
        checkFeatureFlagGate(featureFlags.cpapiwdPricingAll);
    }, []);
    // FYI, this is currently JA only, since we only have JA work space appId
    const isBootIntercom: boolean = FeatureGates.checkGate(
        "gwp-737-enable-intercom-chat-jsm"
    );

    const [
        pricingDirectBuyCheckoutAaFired,
        pricingDirectBuyCheckoutfireExposureAa
    ] = useExperimentExposure(experiments.pricingDirectBuyCheckoutAA);
    useEffect(() => {
        if (!pricingDirectBuyCheckoutAaFired) {
            pricingDirectBuyCheckoutfireExposureAa();
        }
    }, [
        pricingDirectBuyCheckoutAaFired,
        pricingDirectBuyCheckoutfireExposureAa
    ]);

    const pricingTitleInternal = getPricingTitleInternal();

    return (
        <IntercomProvider appId={"p0ww63i2"} triggerBoot={isBootIntercom}>
            <PricingContentContextProvider
                productId="jira-service-management"
                pricingContent={pricingContent}
                pricingTitleInternal={pricingTitleInternal}
            >
                <div data-testid="jsm-pricing-page">
                    <JiraServiceManagementPricingPageV2Template
                        pricing={pricing}
                        countryCode={countryCode}
                    />
                </div>
            </PricingContentContextProvider>
        </IntercomProvider>
    );
};
